export default "__VITE_ASSET__5nR32zWS__"